import * as React from "react";
import * as i from "../../../../../contracts";
import { ServingIndicator } from "../../ServingIndicator";

export const renderTeam = (event: i.Event, onServe: string, componentPrefix: string) =>
    <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__team-${onServe}-name`} data-uat={`div-ev-list-${componentPrefix}-team-name`}>
        {<ServingIndicator onServe={onServe} event={event}/>}
        <span className="rj-ev-list__name-text" data-uat="span-ev-list-name-text">{event[`team${onServe}name`]}</span>
    </div>